import { render } from "./BookmarkButton.vue?vue&type=template&id=7d0c9f33&scoped=true"
import script from "./BookmarkButton.vue?vue&type=script&lang=js"
export * from "./BookmarkButton.vue?vue&type=script&lang=js"

import "./BookmarkButton.vue?vue&type=style&index=0&id=7d0c9f33&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0c9f33"],['__file',"resources/js/components/BookmarkButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d0c9f33"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d0c9f33', __exports__)) {
    api.reload('7d0c9f33', __exports__)
  }
  
  module.hot.accept("./BookmarkButton.vue?vue&type=template&id=7d0c9f33&scoped=true", () => {
    api.rerender('7d0c9f33', render)
  })

}


export default __exports__